import ServiceCards from '../components/ServiceCards';

export default function Services() {
  return (
    <div className="container py-5">
      <h1 className="h2 fw-bold mb-3">Services</h1>
      <p className="text-secondary">Everything we offer, at a glance.</p>
      <ServiceCards />
    </div>
  );
}
